import { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Messages } from 'primereact/messages';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import _css from './login.module.css';
// import './login.css';
import { Fetch } from '../../shared/Fetch';
import { ILogin } from '../../models/Login';
//import reind from "../../assets/flags/AprilMonth.gif";
import reind from "../../assets/branchRanking/June_2026.gif";
import { Card } from 'primereact/card';
import portalLogo from "../../assets/Images/teklense-logo.jpg";




interface IFormInputs {
    login_Name: string
    login_Password: string
}

const schema = yup.object({
    login_Name: yup.string().required("username is required*"),
    login_Password: yup.string().required("password is required*"),
});


export const Login = () => {
    const message = useRef<any>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, setFocus } = useForm<IFormInputs>({
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (!loading) {
            const form = document.querySelector('form');
            form?.classList.add('invalid_details');
            setTimeout(() => {
                form?.classList.remove('invalid_details');
            }, 550);
        }
    }, [loading]);

    useEffect(() => {
        setFocus("login_Name");
    }, [setFocus]);

    async function onSubmitLogin(data: IFormInputs) {
        // const loginKey: string | null = localStorage.getItem("loginKey");
        // if (loginKey && loginKey === "may I login please") {
        setLoading(true);
        const response = await Fetch("User_Mast/login", "POST", data, null, message);
        if (response) {
            const data: ILogin = await response.json();
            console.log(data);
            sessionStorage.setItem('auth', JSON.stringify(data));
            const prevCeleb = localStorage.getItem('showVideo');
            if (data.id === 1) {
                sessionStorage.setItem('adminAuth', JSON.stringify({
                    isAdminAuth: true
                }));
            };
            if (prevCeleb === null) {
                const celeb = { view: true };
                localStorage.setItem('showVideo', JSON.stringify(celeb));
            }
            navigate('/');
        } else {
            setLoading(false);
        }
        // } else message.current.show({ severity: 'error', detail: "Sorry, You can't Login from this System!", life: 3000 });
    }

    return (
        <div className="login-body">
            <div className="login-wrapper">
                <div className="login-panel">
                    <img src={portalLogo} width={388} alt="jobvritta" />
                    <form onSubmit={handleSubmit(onSubmitLogin)} className="col-12">
                        <Card className="">
                            <h5>Login</h5>
                            <Messages ref={message} />
                            <div className="grid p-fluid">
                                <div className="col-12 md:col-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-user"></i>
                                        </span>
                                        <Controller name='login_Name' control={control} defaultValue={''} render={({ field, fieldState }) => (
                                            <InputText {...field} className={classNames({ 'p-invalid': fieldState.invalid })} placeholder="UserName" />
                                        )} />
                                    </div>
                                </div>
                                <small className="p-error" style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}>{errors.login_Name?.message}</small>
                                <div className="col-12 md:col-12">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-lock"></i>
                                        </span>
                                        <Controller name='login_Password' control={control} defaultValue={''} render={({ field, fieldState }) => (
                                            <InputText {...field} className={classNames({ 'p-invalid': fieldState.invalid })} type="password" placeholder="Password" />
                                        )} />
                                    </div>
                                </div>
                                <small className="p-error" style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}>{errors.login_Password?.message}</small>
                                <div className="col-12 md:col-12">
                                    <Button label="LOGIN" type="submit" loading={loading}></Button>
                                </div>
                            </div>
                        </Card>
                    </form>
                    <p></p>
                </div>
                {/* <div className={`login-image ${_css.wrapper}`}>
                    <h1>Access to your <span style={{ color: '#05A7E0' }}>Job</span><span style={{ color: '#EA6E27' }}>Vritta</span> Account</h1>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                </div> */}
                <div className="login-image">
                    {/* <img src={flag2} alt="flag2" width={"50%"} height={"100%"} style={{zIndex:1, marginLeft:"-95vh",marginTop:"-4vh"}}  /> */}
                    <div className={`login-image-content ${_css.container}`} style={{ marginTop: "3vh" }}>
                        <h1>Access to your</h1>
                        <h1>TEKLense</h1>
                        <h1>Account</h1>
                        <br />
                        <div style={{ marginBottom: "60px", height: "450px", width: "65vw", border: "5px solid #800000" }} >
                            <img src={reind} alt="reind" width={"100%"} height={"100%"} />
                        </div>
                        {/* <div style={{ marginBottom: "60px", height: "450px", width: "65vw"   }} >
                        <video width="100%" height="500" controls autoPlay muted >
                        <source src={JobvrittaVideo} type="video/mp4" /> </video>
                        </div> */}
                    </div>
                    {/* <img src={reind} alt="reind" width={"30%"} height={"40%"} style={{ marginRight:"5vh"}} /> */}
                </div>
            </div>
        </div>
    );
};
